import { Helmet } from "react-helmet";
import backgroundImage from "../images/dr-tayfun-giyik-anasayfa.jpeg";

function Hero() {
  // WhatsApp bağlantısını oluştur
  const phoneNumber = "905349214602"; // Ülke kodu ile numara
  const defaultMessage =
    "Merhaba, web sitenizden ulaşıyorum. Danışma randevusu almak istiyorum.";
  const whatsappUrl = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(
    defaultMessage
  )}`;

  return (
    <section
      className="hero"
      style={{
        background: `linear-gradient(rgba(26, 82, 118, 0.85), rgba(26, 82, 118, 0.9)), url(${backgroundImage}) center/cover no-repeat`,
      }}
    >
      <Helmet>
        <title>
          Dr. Tayfun Giyik - Medikal Estetik Uygulamaları | Bakırköy, İstanbul
        </title>
        <meta
          name="description"
          content="Dr. Tayfun Giyik - Botoks, dolgu, PRP, mezoterapi ve medikal estetik uygulamalar. Bakırköy, İstanbul'da hizmet vermektedir."
        />
        <link rel="canonical" href="https://www.drtayfungiyik.com.tr/" />
        <meta
          property="og:title"
          content="Dr. Tayfun Giyik - Medikal Estetik Uygulamaları"
        />
        <meta
          property="og:description"
          content="Doğallığın ve zarafetin bilimle buluştuğu nokta. Medikal estetik çözümleri."
        />
      </Helmet>
      <div className="hero-content">
        <h1>Dr. Tayfun Giyik</h1>
        <p className="title">Medikal Estetik Uygulamaları</p>
        <p className="tagline">
          Doğallığın ve Zarafetin Bilimle Buluştuğu Nokta
        </p>
        <a
          href={whatsappUrl}
          className="cta-button"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="WhatsApp'tan randevu al"
        >
          <span style={{ marginRight: "8px" }}>📱</span> WhatsApp'tan Hemen
          Danışın
        </a>
        <p style={{ marginTop: "1rem", fontSize: "0.9rem", opacity: 0.8 }}>
          En hızlı yanıtı WhatsApp üzerinden alırsınız.
        </p>
      </div>
    </section>
  );
}

export default Hero;
